import { ui } from '@/constants';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { GETTERS as RESTAURANT_GETTERS } from '@/store/restaurant';
import { capitalizeEveryWord, isDesktop } from '@/helpers';
import { FooterMode } from '@/store/ui';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderPage',
  beforeRouteLeave(to, from, next) {
    this.$services.ui.popFooterState();

    next();
  },
})
export default class CmgNutritionCalculatorMealBuilderPage extends Vue {
  doneLoading = false;
  lastIsDesktop = false;
  windowTop = 0;
  
  get selectedRestaurantId(): number {
    return this.$appStore.getters[RESTAURANT_GETTERS.GET_SELECTED_RESTAURANT_ID];
  }
  get isDesktop(): boolean {
    return isDesktop(this.$appStore.state);
  }

  get isCollapsed(): boolean {
    return this.windowTop > 90 && this.$appStore.state.ui.clientWidth >= ui.breakpoints.desktop;
  }

  onScroll() {
    this.windowTop = window.scrollY;
  }
  
  @Watch('selectedRestaurantId', { immediate: false, deep: true })
  async onRestaurantChanged(selectedRestaurantId: number) {
    this.doneLoading = false;
    this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
    this.$services.mealBuilderV2.removeInvalidItems();
  }

  @Watch('isDesktop', { immediate: true, deep: true })
  async onIsDesktopChanged(isDesktop: boolean) {
    if (this.lastIsDesktop !== isDesktop) {
      this.lastIsDesktop = isDesktop;
      this.doneLoading = false;
      this.doneLoading = await this.$services.monoMenu.awaitCacheItems();
    }
  }

  async mounted() {
    window.addEventListener('scroll', this.onScroll);
    this.$services.ui.pushFooterState({ mode: FooterMode.None });
    this.lastIsDesktop = this.isDesktop;
    this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
  }
  
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
